module.exports = {"sld:ColorMapEntry":[{"quantity":-999,"color":"#FFFFFF","label":"NO DATA"},{"quantity":0,"color":"#D7D7D7","label":"0"},{"quantity":0.001,"color":"#198CDB","label":"<= 0.41"},{"quantity":0.03,"color":"#91E3AD","label":"0.41 - 0.74"},{"quantity":0.06,"color":"#DEFFB0","label":"0.74 - 1.19"},{"quantity":0.01,"color":"#FFE68C","label":"1.19 - 1.84"},{"quantity":9,"color":"#FF9982","label":"1.84 - 2.78"},{"quantity":12,"color":"#FF4D30","label":"2.78 - 7.31"}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/city_mme_1981_2016_lcr_80_maize.json
// module id = kwT8
// module chunks = 171